 document.addEventListener("DOMContentLoaded", function () {
    const container = document.querySelector(".scrollingSliderItems");
    if (!container) return;
    const boxes = Array.from(container.querySelectorAll(".scrollSlideLogo"));
    const CLONE_COUNT = 3;
    for (let i = 0; i < CLONE_COUNT; i++) {
        boxes.forEach((box) => {
            container.appendChild(box.cloneNode(true));
        });
    }
    const scrollDistance = container.scrollWidth / 2;
    const SPEED = 30;
    const duration = scrollDistance / SPEED;
    const animation = gsap.to(container, {
        x: -scrollDistance,
        duration: duration,
        ease: "linear",
        repeat: -1,
    });
    container.addEventListener("mouseenter", () => animation.pause());
    container.addEventListener("mouseleave", () => animation.resume());
});